import { DocIdToDocument } from "../documentsReducer"

export const ADD_DOCUMENTS = "ADD_DOCUMENTS"

export interface AddDocumentsAction {
    type: string
    data: DocIdToDocument
}

export const createAddDocumentsAction = (data: DocIdToDocument): AddDocumentsAction => ({
    type: ADD_DOCUMENTS,
    data
})